module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-hp__wrapper"
  }, [_c('div', {
    ref: "parent",
    staticClass: "cb-header cb-transition__slide",
    attrs: {
      "id": "cb-header"
    }
  }, [_c('header-1', {
    directives: [{
      name: "cb-slide",
      rawName: "v-cb-slide",
      value: ({
        isnew: true,
        ref: _vm.$refs.parent
      }),
      expression: "{ isnew : true , ref: $refs.parent }"
    }],
    key: _vm.$route.path,
    tag: "component"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "cb-body",
    attrs: {
      "id": "cb-body",
      "role": "main"
    }
  }, [_c('div', {
    staticClass: "cb-body__content"
  }, [_c('div', {
    directives: [{
      name: "cb-animate",
      rawName: "v-cb-animate",
      value: (true),
      expression: "true"
    }],
    staticClass: "cb-body__wrap"
  }, [_c('div', {
    staticClass: "cb-section cb-bar"
  }, _vm._l((_vm.linked_handles), function(linked_handle, index) {
    return _c('div', {
      directives: [{
        name: "cb-link",
        rawName: "v-cb-link",
        value: ('shadow'),
        expression: "'shadow'"
      }],
      key: index,
      staticClass: "cb-bar__wrap",
      attrs: {
        "role": "navigation",
        "data-cb-id": "choose_account"
      },
      on: {
        "click": function($event) {
          _vm.load(linked_handle)
        }
      }
    }, [_c('div', {
      staticClass: "cb-bar__title"
    }, [_vm._v(_vm._s(_vm.st('account_txt')) + " #" + _vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "cb-bar__content"
    }, [_c('span', {
      staticClass: "cb-bar__desc"
    }, [_vm._v(_vm._s(_vm.st('account_signup')))]), _vm._v(" "), _c('span', {
      staticClass: "cb-bar__desc"
    }, [_vm._v(_vm._s(_vm.date(linked_handle.created_at)))])]), _vm._v(" "), (_vm.additionalSummaryInfo(linked_handle.handle)) ? _c('div', {
      directives: [{
        name: "cb-html",
        rawName: "v-cb-html",
        value: (_vm.additionalSummaryInfo(linked_handle.handle)),
        expression: "additionalSummaryInfo(linked_handle.handle)"
      }],
      staticClass: "cb-truncate"
    }) : _vm._e()])
  }))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-408e6378"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/portal/AccountChooser.vue
// module id = 592
// module chunks = 66